<template>
  <div class="business-definitions">
    <div class="fake-single-select">{{ title }}</div>
    <BittsSelect
      model-value="is"
      :disabled="true"
      class="middle-select"
      aria-label="Filter operator"
    />
    <BittsFilterMultiselect
      v-if="isMultiSelect"
      v-model="multiSelectModel"
      class="right-hand-side-select"
      placeholder="Select values"
      :disabled="operandOptions.length === 0 || isDisabled"
      :options="operandOptions"
      :use-overflow="true"
      :use-search="true"
    />
    <BittsSelect
      v-else
      v-model="selectedOperands"
      class="right-hand-side-select"
      placeholder="Select value"
      :disabled="operandOptions.length === 0 || isDisabled"
      :options="operandOptions"
      size="medium"
      aria-label="Filter value"
    />
  </div>
</template>
<script setup lang="ts">
import { BittsFilterMultiselect, BittsSelect } from '@crossbeam/bitts';

import { computed } from 'vue';

import { CoercedOperand } from '@/types/business_settings';

const {
  isMultiSelect = true,
  operandOptions,
  isDisabled = false,
} = defineProps<{
  isMultiSelect: boolean;
  operandOptions: { label: string; value: string }[];
  title: string;
  isDisabled: boolean;
}>();

const selectedOperands = defineModel<CoercedOperand>();

/** Narrow the model to string[] for BittsFilterMultiselect. */
const multiSelectModel = computed({
  get: () =>
    Array.isArray(selectedOperands.value) ? selectedOperands.value : [],
  set: (val: string[]) => {
    selectedOperands.value = val;
  },
});
</script>

<style scoped lang="pcss">
@reference "../css/theme.css";
.business-definitions {
  @apply flex h-32;
}

.fake-single-select {
  @apply text-neutral-text px-12 py-8 border border-neutral-border
  rounded-tl-lg rounded-bl-lg shadow-component border-r-0 cursor-default
  text-base flex items-center shrink-0;
}

.right-hand-side-select {
  @apply w-full min-w-[160px] lg:min-w-[300px] lg:w-auto;
}

/* right select when in multi-select mode (BittsFilterMultiselect) */
:deep(.bitts-filter-multiselect__trigger) {
  @apply rounded-l-none! border-l-0!;
}

/* right select when in single select mode (BittsSelect) */
:deep(.bitts-select.right-hand-side-select .ant-select-selector) {
  @apply rounded-l-none! border-l-0!;
}

/* middle select "operator" (BittsSelect) */
:deep(.bitts-select.middle-select) {
  .ant-select {
    @apply h-full!;
  }

  .ant-select-single .ant-select-selector {
    @apply h-full! rounded-none! border-l-0!;
  }
}
</style>
